/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-07-01 13:33:41
 * @LastEditors: linxi
 * @LastEditTime: 2025-04-28 18:30:15
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../../app/store'
import { Tenant } from '../../../models/tenant'
import * as service from '../../../services/setting'

interface settingState {
  tenant?: Tenant
  settings: any
  autoCreateFeeVOList: any
  nextSendDay: string
  isChange: boolean
}

const initialState: settingState = {
  settings: [],
  autoCreateFeeVOList: [],
  nextSendDay: '',
  isChange: false,
}

const settingSlice = createSlice({
  name: 'settingSlice',
  initialState,
  reducers: {
    setDetail: (state, action) => {

      state.tenant = action.payload.tenant
      state.settings = _.reduce(
        action.payload.functionList,
        (acc, { type, value }) => ({
          ...acc,
          [type]: value === 'true' ? true : value === 'false' ? false : value,
        }),
        {}
      )
      state.autoCreateFeeVOList = action.payload?.autoCreateFeeVOList?.map(
        (v: any) => {
          return {
            ...v,
            conditionDataName: v?.conditionData
              ?.map((m: any) => m.name)
              ?.join(','),
            projectDataName: v?.projectData?.map((m: any) => m.name)?.join(','),
          }
        }
      )
      state.nextSendDay = action.payload?.functionList
        ?.find((v: any) => v.type == 27)
        ?.updateTime?.split(' ')[0]
    },
    setNextSendDay: (state, action) => {
      state.nextSendDay = action.payload
    },
    setIsChange: (state, action) => {
      state.isChange = action.payload
    },
  },
})

export const { setDetail, setNextSendDay, setIsChange } = settingSlice.actions

export const selectTenant = (state: RootState) => state.settinglable.tenant
export const selectAutoCreateFeeVOList = (state: RootState) =>
  state.settinglable.autoCreateFeeVOList

export const selectSettings = (state: RootState): any =>
  state.settinglable.settings

export const selectIsChange = (state: RootState): boolean =>
  state.settinglable.isChange

export const selectNextSendDay = (state: RootState): any =>
  state.settinglable.nextSendDay

export const saveSettingLabel = createAsyncThunk<
  void,
  service.SettingMessageParams,
  RootThunkApi
>('setting/getSettingStatus', async (body, api) => {
  return sendAsync(service.getSettingSave(body), api)
})

export function getSettingDetail(): RootThunk {
  return api(service.getSettingDetail(), (data, dispatch) => {
    dispatch(setDetail(data))
  })
}

export default settingSlice.reducer
